module.exports = __webpack_public_path__ + "media/images/icons/icon-new-banner-tail-674ecb30296a364d35e8009b9a52056b.svg";